import * as actionTypes from './actionTypes';

export const mapSeparationNextStep = () => {
  return {
    type : actionTypes.MAP_SEPARATION_NEXT_STEP,
    val : null
  }
}

export const mapSeparationGoBack = () => {
  return {
    type : actionTypes.MAP_SEPARATION_PREVIOUS_STEP,
    val : null
  }
}

export const mapSeparationUploadFileSuccess = (columns, data, file) => {
  return {
    type : actionTypes.MAP_SEPARATION_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapSeparationMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_SEPARATION_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllSeparationMapping = (val) => {
  return {
    type : actionTypes.MAP_SEPARATION_SAVE_SEPARATION_MAPPING,
    val : val
  }
}

export const resetSeparations = () => {
  return {
    type : actionTypes.MAP_SEPARATION_RESET,
    val : null
  }
}

export const resetMapSeparationStep = () => {
  return {
    type : actionTypes.MAP_SEPARATION_RESET_STEP,
    val : null
  }
}